module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40bdb123f50c303bc8471cf1b50e52a5.png";